import React from 'react';
import { SNFContainer } from 'components/searchAndFilter';

const SearchAndFilter = (props) => {
  return <SNFContainer {...props} />;
};

export default SearchAndFilter;
